module.exports = __webpack_public_path__ + "static/rc-4-5ba7f4fcc10ec2c2e130a45f347a5b31.jpg";